import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { 
  FaTimes,
  FaUser,
  FaHome,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaClock,
  FaCalendarAlt,
  FaChild,
  FaPills,
  FaFirstAid,
  FaWhatsapp,
  FaChevronDown,
  FaChevronUp,
  FaMoneyBillWave,
  FaHandshake
} from "react-icons/fa";
import { GiPayMoney } from "react-icons/gi";

export default function ModalInfoUser({ selectedData, handleCloseModal }) {
  const [showChildDetails, setShowChildDetails] = useState(false);

  // Animaciones
  const modalVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 20 }
  };

  const childVariants = {
    hidden: { opacity: 0, height: 0 },
    visible: { opacity: 1, height: "auto" }
  };

  return (
    <div className="fixed z-50 inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <motion.div
        initial="hidden"
        animate="visible"
        exit="exit"
        variants={modalVariants}
        transition={{ duration: 0.3 }}
        className="bg-white rounded-lg shadow-lg max-w-lg p-6 relative max-h-[80vh] overflow-y-auto"
      >
        {/* Botón de cierre */}
        <motion.button
          onClick={handleCloseModal}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          <FaTimes className="text-xl" />
        </motion.button>

        {/* Título del modal */}
        <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
          <FaUser className="mr-2 text-blue-500" />
          Detalles de Padres
        </h3>

        {/* Información del padre/madre */}
        <div className="mb-6 space-y-3">
          <div className="flex items-start">
            <FaUser className="mt-1 mr-2 text-gray-600 min-w-[20px]" />
            <p>
              <span className="font-semibold">Nombre:</span>{" "}
              {selectedData.mother?.name || "No especificado"}
            </p>
          </div>
          
          <div className="flex items-start">
            <FaHome className="mt-1 mr-2 text-gray-600 min-w-[20px]" />
            <p>
              <span className="font-semibold">Dirección:</span>{" "}
              {selectedData.mother?.address || "No especificado"}
            </p>
          </div>
          
          <div className="flex items-start">
            <FaMapMarkerAlt className="mt-1 mr-2 text-gray-600 min-w-[20px]" />
            <p>
              <span className="font-semibold">Barrio:</span>{" "}
              {selectedData.mother?.neighborhood || "No especificado"}
            </p>
          </div>
          
          <div className="flex items-start">
            <FaPhone className="mt-1 mr-2 text-gray-600 min-w-[20px]" />
            <p>
              <span className="font-semibold">Teléfono:</span>{" "}
              {selectedData.mother?.phone || "No especificado"}
            </p>
          </div>
          
          <div className="flex items-start">
            <FaEnvelope className="mt-1 mr-2 text-gray-600 min-w-[20px]" />
            <p>
              <span className="font-semibold">Email:</span>{" "}
              {selectedData.mother?.email || "No especificado"}
            </p>
          </div>
        </div>

        {/* Detalles del servicio */}
        <div className="mb-6">
          <h4 className="text-lg font-bold text-gray-800 mb-3 flex items-center">
            <FaClock className="mr-2 text-blue-500" />
            Detalles del Servicio
          </h4>
          
          <div className="space-y-3 pl-6">
            <div className="flex items-start">
              <FaClock className="mt-1 mr-2 text-gray-600 min-w-[20px]" />
              <p>
                <span className="font-semibold">Horario:</span>{" "}
                {selectedData.mother?.services[0]?.schedule || "No especificado"}
              </p>
            </div>
            
            <div className="flex items-start">
              <FaCalendarAlt className="mt-1 mr-2 text-gray-600 min-w-[20px]" />
              <div>
                <span className="font-semibold">Días:</span>{" "}
                <div className="flex flex-wrap gap-2 mt-1">
                  {selectedData.mother?.services[0]?.days?.map((dia, index) => (
                    <motion.span
                      key={index}
                      initial={{ scale: 0.9 }}
                      animate={{ scale: 1 }}
                      className="inline-block bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-sm"
                    >
                      {dia}
                    </motion.span>
                  )) || "No especificado"}
                </div>
              </div>
            </div>
            
            <div className="flex items-start">
              <FaHandshake className="mt-1 mr-2 text-gray-600 min-w-[20px]" />
              <p>
                <span className="font-semibold">Tipo de Servicio:</span>{" "}
                {selectedData.mother?.services[0]?.plan || "No especificado"}
              </p>
            </div>
            
            <div className="flex items-start">
              <FaHandshake className="mt-1 mr-2 text-gray-600 min-w-[20px]" />
              <p>
                <span className="font-semibold">Modalidad de Contratación:</span>{" "}
                {selectedData.mother?.services[0]?.contratacion || "No especificado"}
              </p>
            </div>
            
            <div className="flex items-start">
              <FaMoneyBillWave className="mt-1 mr-2 text-gray-600 min-w-[20px]" />
              <p>
                <span className="font-semibold">Propuesta Económica:</span>{" "}
                {selectedData.mother?.services[0]?.propuestaEconomica || "No especificado"}
              </p>
            </div>
            
            <div className="flex items-start">
              <GiPayMoney className="mt-1 mr-2 text-gray-600 min-w-[20px]" />
              <p>
                <span className="font-semibold">Tipo de Pago:</span>{" "}
                {selectedData.mother?.services[0]?.typePago || "No especificado"}
              </p>
            </div>
          </div>
        </div>

        {/* Detalles del niño (colapsable) */}
        <div className="mb-6">
          <motion.button
            onClick={() => setShowChildDetails(!showChildDetails)}
            className="w-full text-left text-lg font-bold text-gray-800 mb-2 flex justify-between items-center"
            whileHover={{ backgroundColor: "#f3f4f6" }}
            whileTap={{ scale: 0.98 }}
          >
            <div className="flex items-center">
              <FaChild className="mr-2 text-blue-500" />
              <span>Detalles del Niño</span>
            </div>
            {showChildDetails ? <FaChevronUp /> : <FaChevronDown />}
          </motion.button>

          <AnimatePresence>
            {showChildDetails && (
              <motion.div
                initial="hidden"
                animate="visible"
                exit="hidden"
                variants={childVariants}
                transition={{ duration: 0.2 }}
                className="pl-6 border-l-2 border-gray-200 overflow-hidden"
              >
                {selectedData.mother?.services[0]?.childer?.map((child, index) => (
                  <motion.div 
                    key={index} 
                    className="mb-4 space-y-3"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: index * 0.1 }}
                  >
                    <div className="flex items-start">
                      <FaChild className="mt-1 mr-2 text-gray-600 min-w-[20px]" />
                      <p>
                        <span className="font-semibold">Nombre:</span>{" "}
                        {child.name || "No especificado"}
                      </p>
                    </div>
                    
                    <div className="flex items-start">
                      <FaChild className="mt-1 mr-2 text-gray-600 min-w-[20px]" />
                      <p>
                        <span className="font-semibold">Edad:</span>{" "}
                        {child.age || "No especificado"}
                      </p>
                    </div>
                    
                    <div className="flex items-start">
                      <FaFirstAid className="mt-1 mr-2 text-gray-600 min-w-[20px]" />
                      <p>
                        <span className="font-semibold">Cuidados Especiales:</span>{" "}
                        {child.specialCare || "No especificado"}
                      </p>
                    </div>
                    
                    <div className="flex items-start">
                      <FaPills className="mt-1 mr-2 text-gray-600 min-w-[20px]" />
                      <p>
                        <span className="font-semibold">Toma Medicación:</span>{" "}
                        {child.takesMedication ? "Sí" : "No"}
                      </p>
                    </div>
                  </motion.div>
                ))}
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        {/* Botón de WhatsApp */}
        <motion.button
          onClick={() => {
            const motherName = selectedData.mother?.name;
            const motherPhone = selectedData.mother?.phone;
            const message = `Hola ${motherName}, me comunico en relación al servicio que estamos coordinando.`;
            const whatsappURL = `https://wa.me/${motherPhone}?text=${encodeURIComponent(
              message
            )}`;
            window.open(whatsappURL, "_blank");
          }}
          className="w-full px-4 py-3 bg-green-500 text-white rounded-lg hover:bg-green-600 flex items-center justify-center gap-2"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <FaWhatsapp className="text-xl" />
          Enviar WhatsApp
        </motion.button>
      </motion.div>
    </div>
  );
}